import Vue from 'vue'
import Vuex from 'vuex'
import { firebaseAuth, firebaseDatabase } from '@/services/firebase'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    pillar1: null,
    pillar2: null,
    pillar3: null,
    pillar4: null,
    pillar5: null,
  },
  mutations: {
    setPillar1(state, pillarOne) {
      state.pillar1 = pillarOne
    },
    setPillar2(state, pillarTwo) {
      state.pillar2 = pillarTwo
    },
    setPillar3(state, pillarThree) {
      state.pillar3 = pillarThree
    },
    setPillar4(state, pillarFour) {
      state.pillar4 = pillarFour
    },
    setPillar5(state, pillarFive) {
      state.pillar5 = pillarFive
    },
  },
  actions: {
    async getPillars(context) {
      const pillars = []
      firebaseDatabase.collection('pillars')
        .where('userID', '==', firebaseAuth.currentUser.uid)
        .where('active', '==', true)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const data = {
              pillarID: doc.id,
              pillarName: doc.data().pillarName,
              description: doc.data().description,
              active: doc.data().active,
            }
            pillars.push(data)
          })
          if (pillars.length === 0) {
          } else if (pillars.length === 1) {
            const pillarOne = pillars[0]
            context.commit('setPillar1', pillarOne)
            context.dispatch('strategy/keywords/getKeywords1', pillarOne, { root: true })
          } else if (pillars.length === 2) {
            const pillarOne = pillars[0]
            const pillarTwo = pillars[1]
            context.commit('setPillar1', pillarOne)
            context.commit('setPillar2', pillarTwo)
            context.dispatch('strategy/keywords/getKeywords1', pillarOne, { root: true })
            context.dispatch('strategy/keywords/getKeywords2', pillarTwo, { root: true })
          } else if (pillars.length === 3) {
            const pillarOne = pillars[0]
            const pillarTwo = pillars[1]
            const pillarThree = pillars[2]
            context.commit('setPillar1', pillarOne)
            context.commit('setPillar2', pillarTwo)
            context.commit('setPillar3', pillarThree)
            context.dispatch('strategy/keywords/getKeywords1', pillarOne, { root: true })
            context.dispatch('strategy/keywords/getKeywords2', pillarTwo, { root: true })
            context.dispatch('strategy/keywords/getKeywords3', pillarThree, { root: true })
          } else if (pillars.length === 4) {
            const pillarOne = pillars[0]
            const pillarTwo = pillars[1]
            const pillarThree = pillars[2]
            const pillarFour = pillars[3]
            context.commit('setPillar1', pillarOne)
            context.commit('setPillar2', pillarTwo)
            context.commit('setPillar3', pillarThree)
            context.commit('setPillar4', pillarFour)
            context.dispatch('strategy/keywords/getKeywords1', pillarOne, { root: true })
            context.dispatch('strategy/keywords/getKeywords2', pillarTwo, { root: true })
            context.dispatch('strategy/keywords/getKeywords3', pillarThree, { root: true })
            context.dispatch('strategy/keywords/getKeywords4', pillarFour, { root: true })
          } else {
            const pillarOne = pillars[0]
            const pillarTwo = pillars[1]
            const pillarThree = pillars[2]
            const pillarFour = pillars[3]
            const pillarFive = pillars[4]
            context.commit('setPillar1', pillarOne)
            context.commit('setPillar2', pillarTwo)
            context.commit('setPillar3', pillarThree)
            context.commit('setPillar4', pillarFour)
            context.commit('setPillar5', pillarFive)
            context.dispatch('strategy/keywords/getKeywords1', pillarOne, { root: true })
            context.dispatch('strategy/keywords/getKeywords2', pillarTwo, { root: true })
            context.dispatch('strategy/keywords/getKeywords3', pillarThree, { root: true })
            context.dispatch('strategy/keywords/getKeywords4', pillarFour, { root: true })
            context.dispatch('strategy/keywords/getKeywords5', pillarFive, { root: true })
          }
        })
    },
    insertPillar(context, newPillar) {
      if (!this.state.strategy.pillars.pillar1) {
        context.commit('setPillar1', newPillar)
      } else if (!this.state.strategy.pillars.pillar2) {
        context.commit('setPillar2', newPillar)
      } else if (!this.state.strategy.pillars.pillar3) {
        context.commit('setPillar3', newPillar)
      } else if (!this.state.strategy.pillars.pillar4) {
        context.commit('setPillar4', newPillar)
      } else if (!this.state.strategy.pillars.pillar5) {
        context.commit('setPillar5', newPillar)
      } else console.log('5 pillars already set.')
    },
    removePillar(context, removedPillar) {
      if (removedPillar.pillarID === this.state.strategy.pillars.pillar1.pillarID) {
        context.commit('setPillar1', null)
      } else if (removedPillar.pillarID === this.state.strategy.pillars.pillar2.pillarID) {
        context.commit('setPillar2', null)
      } else if (removedPillar.pillarID === this.state.strategy.pillars.pillar3.pillarID) {
        context.commit('setPillar3', null)
      } else if (removedPillar.pillarID === this.state.strategy.pillars.pillar4.pillarID) {
        context.commit('setPillar4', null)
      } else context.commit('setPillar5', null)
    },
  },
  getters: {
    state: state => state,
    pillar1: state => state.pillar1,
  },
}
